export const m = {
  //公用的文字
  cancel:'Cancel',
  confirm:'Confirm',
  save:'Save',
  addtext:'Add text',
  addimg:'Add image',
  modify_information:'Modify information',
  wechat_share:'Swipe with WeChat, enter the page and follow the prompts to share.',
  delete:'delete',
  has_chosen:'has chosen:',
  has_chosen2:'',
  select:'please select',
  select_img:'Select image',
  suggest:'Suggest upload 720*480 pictures, the size does not exceed 5M',
  suggest2:'Not exceed 5M',
  yuan:'Yuan',
  yuanperhour:'Yuan/hour',
  //关于班级的相关字段（新建、修改、班级信息）
  bj_mode:'Mode',
  bj_select:'select',
  bj_name:'Name',
  bj_words:'Within 10 words',
  bj_type:'Type',
  bj_free:'Free',
  bj_charge:'Charge',
  bj_startdate:'Start Date',
  bj_time:'Time',
  bj_time2:'Time:',       //用在班级成员处
  bj_period:'Period',
  bj_number:'Number',
  bj_price:'Price',
  bj_yuan:'Yuan/hour',
  bj_unitprice:'Unit price',
  bj_setdiscount:'Set discount',
  bj_discount:'Discount',
  bj_discount2:'Discount:',      //用在班级信息里
  bj_yuan2:'Yuan',
  bj_fee:'Fee:',
  bj_free_text:'Free',
  bj_orginal_price:'Original price:',
  bj_introduce:'Introduce',

  //管理后台左侧导航（SideNav）
  sidenav_wxht: 'School Manage',
  sidenav_kclb: 'Course List',
  sidenav_ddgl: 'Order Manage',
  sidenav_tjjs: 'Statistic',
  sidenav_yxhd: ' Marketing',
  sidenav_grzx: 'User Center',
  //网校后台顶部导航
  school_wxht:'Overview',
  school_wxcy:'Members',
  school_wxsz:'Settings',
  //网校后台——网校后台——课件管理
  school_a_goback:'Go back',
  school_a_ke:'',
  school_a_course:'Course:',
  school_a_class:'Class:',
  school_a_time:'Time:',
  school_a_add_courseware:'Add courseware',
  school_a_courseware_cover:'Courseware cover',
  school_a_courseware_name:'Name',
  school_a_courseware_introduce:'Introduce',
  school_a_courseware_operate:'Operate',
  school_a_select_courseware:'Select courseware',
  school_a_new_courseware:'make new courseware',
  //网校后台——网校成员
  school_m_admin_list:'Administrator List',
  school_m_founder:'founder',
  school_m_administrator:'administrator',
  school_m_teacher_list:'Teacher List',
  school_m_invite_teacher:'Invite teacher',
  school_m_score:'Score:',
  school_m_opetate:'opetate',
  school_m_set_administrator:'set as admin',
  school_m_modify_information:'modify info',
  school_m_delete_teacher:'delete',
  school_m_invite_admin:'Invite Administrator',
  school_m_settobe_admin:'Set school teachers as administrators',
  school_m_chose:'has chosen:',
  school_m_chose2:'',
  school_m_avatar:'Avatar:',
  school_m_name:'Name:',
  school_m_sex:'Sex:',
  school_m_type:'Type:',
  school_m_personal_introduce:'Personal Introduce:',
  //网校后台——网校设置
  school_s_basic_information:'School\'s Information',
  school_s_system:'System:',
  school_s_modify:'Modify',
  school_s_introduce:'School\'s Introduce',
  school_s_modify_data:'Modify Information',
  school_s_avatar:'Cover:',
  school_s_name:'Name:',
  school_s_type:'Type:',
  school_s_introduce2:'School\'s Introduce:',
  school_s_addtext:'Add text',
  school_s_addimg:'Add image',
  //课程列表
  cou_n_new_course:'Create new course',
  cou_n_course_title:'Title:',
  cou_n_course_type:'Type:',
  cou_n_course_cover:'Cover:',
  cou_n_course_introduce:'Introduce:',
  cou_n_course_input_title:'Input course title',
  cou_n_gong:'participants:',
  cou_n_gong2:'',
  //课程列表——班级管理
  cou_top_bjgl:'Class Manage',
  cou_top_kjgl:'Courseware Manage',
  cou_top_kcb:'Schedule',
  cou_top_kcyhq:'Course Coupon',
  class_add_teacher:'Add Teacher',
  class_modify_course:'Modify',
  class_share_course:'Share',
  class_preview:'preview',
      //预览课程弹窗(除了标题不一样外，其余文字部分同新建课程中的部分)
  class_pre_sectionTitle:'Course Preview',
      //修改课程弹窗(除了标题不一样外，其余文字部分同新建课程中的部分)
  class_modify_sectionTitle:'Modify Course',
      //分享课程弹窗
  class_share_sectionTitle:'Share Course',
      //添加授课老师弹窗
  class_addteacher_sectionTitle:'Add Teacher',
  class_addteacher_teacherNow:'Current teacher for this course:',
  class_addteacher_inviteTeacher:'Invite teacher',
      //邀请老师弹窗
  class_inviteteacher_sectionTitle:'Invite Teacher',

  class_more:'more',
  //视频录制
  class_makedemovideo:'Make demo video',
  class_v_step1:'1.Set recording time',
  class_v_minute:'minutes',
  class_v_hint:'Suggest 5~15 minutes',
  class_v_step2:'2.Select courseware',
  class_v_hint2:'Select courseware or go to \'Courseware Manage\' to make some new',
  class_v_step3:'3.Go to make demo',
  class_v_gomake:'Make',
  class_v_next:'Next',
  class_v_preview:'Preview',
  class_v_notSatisfied1:'Not satisfied,click',
  class_v_notSatisfied2:'Re-make',
  class_v_upload:'Upload',


  class_new_class:'Create new class',
  class_modify_class:'Modify class',
  class_free_class:'free',
  class_enroll:'enrollment:',
  class_enroll2:'',
  class_time:'Time:',
  class_classinfo:'details',
  class_openlive:'open live',
  class_startsell:'start selling',
  class_stopsell:'stop selling',
  class_delete:'delete',
  class_modify:'modify',
  class_share:'share',
  class_copy:'copy',
      //分享班级弹窗
  class_share_text:'Share Class',
      //删除班级弹窗
  class_delete_text:'Are you sure you want to delete this class?',
      //班级下架弹窗
  class_offsell_text:'Are you sure you want to abolish enrolment?',
  class_numbers1:'total numbers:',
  class_numbers2:';',

  //班级管理——班级信息
  class_details:'Class Details',
  class_schedule:'Class Schedule',
  class_member:'Members',
  class_coupon:'Class Coupon',
  class_back:'Go back',

  //班级管理——班级成员
  class_mem_list:'List of students(',
  class_mem_list2:'people)',
  class_mem_noresult:'No result',
  class_mem_haspayed:'Has payed:',
  class_mem_registration_time:'Registration Time:',        //同订单管理的报名时间（此项由冒号）
  class_mem_showall:'Show All',
  class_mem_search:'Search by time',
  class_mem_search_text:'Search',
  //班级管理——优惠券(其余部分参考营销活动——优惠券)
  class_cou_add_coupon:'Add class\'s coupon',
  class_cou_sub_explain:'Class\'s coupons are only available for the current class',

  //课程列表——课程优惠券
  cou_cou_explain_title:'Explanation of course coupon',
  cou_cou_explain_1:'1.Coupon amount must be greater than 0 yuan, can be used as cash payment.',
  cou_cou_explain_2:'2.The coupons are applicable to all classes under the current course.',
  cou_cou_explain_3:'3.Coupons need to set the total number of sheets, support multiple sharing or forwarding until the end.',
  cou_cou_addcoupon:'Add course\'s coupon',
  cou_cou_sub_explain_title:'Course\'s coupons are available for all classes of this course',

  //课程列表——课件/备课
  cou_ware_addware:'Add courseware',
  cou_ware_btn1:'Make new ware',
  cou_ware_btn2:'Upload PDF',
  cou_ware_copy:'copy',
  cou_ware_preview:'Preview',
  cou_ware_edit:'Edit',
  cou_ware_createtime:'Create time:',
  cou_ware_makecourseware:'Make courseware',
  cou_ware_title:'Title',
  cou_ware_cover:'Cover',
  cou_ware_introduce:'Introduce',


  //统计结算--报名统计
  sta_b_bmtj:'Course',
  sta_b_kcjs:'Registration',
  sta_b_yjzsr:'Predicted Income(Yuan)',
  sta_b_ktx:'Can be get(Yuan)',
  sta_b_sqtx:'Apply',
  sta_b_ydjsje:'Remaining Income',
  sta_b_period:'(Period:every 3days)',
  sta_b_ljtxje:'Accumulated Money',
  sta_b_zje:'Total(Yuan)',
  sta_b_cktxjl:'View record',
  sta_b_wdzh:'My Account',
  sta_b_bdzfb:'Bind the Alipay:',
  sta_b_srzfb:'Enter the Alipay account',
  sta_b_xmzfb:'Name of Alipay:',
  sta_b_srzfbxm:'Enter name of the account',    //通用
  sta_b_bdwx:'Bind the Wechat:',
  sta_b_srwx:'Enter the Wechat account',
  sta_b_xmwx:'Name of Wechat:',
  sta_b_msbd:'Bind',
  sta_b_bdwxzh:'bind wechat account',
  sta_b_bdzfbzh:'bind alipay account',
  sta_b_aliaccount:'Alipay Account:',
  sta_b_wechatccount:'Wechat Account:',
  sta_b_xgbd:'Modify',
  sta_b_explain1:'Explanation of financial settlement issues:',
  sta_b_explain2:'1.79% of the income belongs to the school teachers;',
  sta_b_explain3:'2.In order to ensure the safety of your funds, please bind the Alipay account.We will make payment to your personal account within 3-7 working days after your applying for withdrawal. ',
  sta_b_jsjlcx:'Settlement Record Inquiry',
  sta_b_zzsk:'Ongoing Class',
  sta_b_yjs:'Finished Class',
  sta_b_bjxx:'Class Info',
  sta_b_xxrs:'Students Numbers',
  sta_b_sksj:'Class Time',
  sta_b_yjsr:'Predicted Income',
  sta_b_dqskjd:'Schedule',
  sta_b_dqjsje:'Received',
  sta_b_ywc:'has finished',
  sta_b_times:'times',
  sta_b_ckxx:'See details',
  //统计结算--报名统计
  sta_r_kcbam:'Course registration statistics',
  sta_r_xzkc:'Select course:',
  sta_r_kcrq:'Time:',
  sta_r_kczq:'Period:',
  sta_r_bmrs:'Enrolment:',
  sta_r_sr:'Income(Yuan):',
  //营销活动——优惠券
  act_c_coupon:'Coupon',
  act_c_explain1:'Explanation of marketing activity',
  act_c_explain2:'1.The current function only supports the addition of online school coupons. Course coupons and class coupons should be added to the corresponding details page.',
  act_c_explain3:'2.Coupon amount must be greater than 0 yuan, can be used as cash payment.',
  act_c_explain4:'3.Coupons need to set the total number of sheets, support multiple sharing or forwarding until the end.',
  act_c_addcoupon:'Add school\'s coupon',
  act_c_ongoing:'Ongoing',
  act_c_history:'History',
  act_c_class_coupon:'Class\'s coupon:',
  act_c_course_coupon:'Course\'s coupon:',
  act_c_school_coupon:'School\'s coupon:',
  act_c_yuan:' yuan',
  act_c_creattime:'Create time:',
  act_c_coupon_school_explain:'apply to all courses and classes in the current online school',
  act_c_coupon_course_explain1:'apply to all classes of',
  act_c_coupon_course_explain2:'',
  act_c_coupon_class_explain1:'apply to ',
  act_c_coupon_class_explain2:'--',
  act_c_coupon_class_explain3:'',
  act_c_total_quantity:'Total quantity:',
  act_c_total_ticket:'',
  act_c_receive:'Already received:',
  act_c_deadline:'Deadline:',
  act_c_share:'Share',
  act_c_explain_school:'School\'s coupons apply to all courses and classes in the current online school.',
  act_c_yhje:'Discount:',
  act_c_minus:'Minus',
  act_c_yuan2:'yuan',
  act_c_number:'Number:',
  act_c_gong:'',
  act_c_zhang:'',
  act_c_deadline2:'Deadline:',
  act_c_cancel:'Cancel',
  act_c_confirm:'Confirm',
  act_c_share_coupon:'Share Coupon',
  act_c_share_explain:'Swipe with WeChat, enter the page and follow the prompts to share.',
  //订单管理——所有订单
  ord_a_all:'Orders',
  ord_a_search_date:'Search by date:',
  ord_a_search_startdate:'start',
  ord_a_search_enddate:'end',
  ord_a_search_phone:'Search by phone',
  ord_a_noresult:'No result',
  ord_a_registration_time:'Registration Time',
  ord_a_name:'Name',
  ord_a_phone:'Phone',
  ord_a_course:'Course',
  ord_a_class:'Class',
  ord_a_pay:'Pay',
  ord_a_details:'Details of order:',
  ord_a_order_number:'Order number:',
  ord_a_order_cancel:'Cancel order',
  ord_a_opentime:'Open time:',
  ord_a_totalnumber:'Total number:',
  ord_a_totalnumber2:'',
  ord_a_period:'Period:',


};



// WEBPACK FOOTER //
// ./src/common/lang/en.js